export enum SyncFormFormFields {
  UPDATED_FROM = 'updatedFrom',
  UPDATED_UNTIL = 'updatedUntil',
  CHANNEL_SLUGS = 'channelSlugs',
  CHANNEL = 'channelSlug',
  TYPE = 'type',
  SKU = 'sku',
}

export enum CleanSyncFormFormFields {
  CHANNEL = 'channelSlug',
}
export type TCleanSyncFormValues = {
  [CleanSyncFormFormFields.CHANNEL]: string;
};

export type TSyncSpecificProductFormValues = {
  [SyncFormFormFields.TYPE]: SyncType.SPECIFIC_PRODUCT;
  [SyncFormFormFields.SKU]: string;
  [SyncFormFormFields.CHANNEL]: string;
};

export type TSyncProductsFormValues = {
  [SyncFormFormFields.TYPE]: SyncType.PRODUCTS | SyncType.PRODUCT_MODELS;
  [SyncFormFormFields.UPDATED_FROM]: string;
  [SyncFormFormFields.UPDATED_UNTIL]: string;
  [SyncFormFormFields.CHANNEL_SLUGS]: string[];
};

export type TSyncFormValues = TSyncSpecificProductFormValues | TSyncProductsFormValues;

export enum SyncType {
  PRODUCTS = 'products',
  PRODUCT_MODELS = 'product-models',
  SPECIFIC_PRODUCT = 'specific-product',
}
